<template lang="pug">
select.BookartSelect
  option( v-for='(option, optI) in model.options', :value='optI' ) {{ option.name }}
</template>

<script>

// Requires 'tether' in node modules
import TetherSelect from './tether-select.js'

export default {
  name: 'bookart-select',
  props: {
    value: {
      required: true
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  mounted () {
    let instance = new TetherSelect({ el: this.$el })
    instance.on('change', e => this.$parent.$emit('select', e.value))
  }
}
</script>

<style lang="stylus">

@import './tether'
@import './select-theme-default'

$lavender = #333
$lavender = #9c84f0

.select-target.select-theme-default
  padding-right: 2rem
  padding-left: 1rem

  padding-top: 0
  padding-bottom: 0
  line-height: 50px

  border-radius: 0 !important
  border: 2px solid
  border-color: $lavender

  background: white

  &:focus
    border-color: $lavender !important

  &:not(.select-open):hover
    background: $lavender
    color: white

.select-content
  box-shadow: none !important

  max-width: 80vw !important

  border-top: 2px solid
  border-bottom: 2px solid
  border-color: $lavender
  border-radius: 0 !important

  position: relative
  top: -1px

  .select-abutted &
    top: 1px

  li.select-option
    border: 2px solid
    border-bottom: none
    border-color: $lavender
    border-radius: 0 !important

    padding-top: 0 !important
    padding-bottom: 0 !important
    line-height: 50px !important

    &.select-option-selected::before
      top: -32px !important

    &:first-child
      border-top: none

    &.select-option-highlight
      border-color: $lavender
      background: $lavender !important

</style>



// WEBPACK FOOTER //
// BookartSelect.vue?2f0c918d